// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"8ba8505c","160":"24a25a5b","208":"a8040679","293":"3fe58d7b","488":"bf65a8d8","516":"503a3d2e","519":"1c341b57","917":"71c76319","946":"4176a3a1"}[chunkId] + ".chunk.js";
};